import { RpcError } from "@protobuf-ts/runtime-rpc";

import { ErrorCode } from "./common/common";

/** Returns a known backend error code from gRPC metadata, when present. */
export const getGrpcErrorCode = (error: unknown): ErrorCode | undefined => {
  if (!(error instanceof RpcError)) {
    return undefined;
  }

  const raw = error.meta.error_code;
  const value = Array.isArray(raw) ? raw[0] : raw;

  if (typeof value !== "string" || !/^\d+$/.test(value)) {
    return undefined;
  }

  const code = Number(value);
  return Number.isSafeInteger(code) &&
    Object.prototype.hasOwnProperty.call(ErrorCode, code)
    ? (code as ErrorCode)
    : undefined;
};
